import yup from 'src/libraries/validator.library';

const PolygonShape = {
  polygon: yup.string().required(),
};

export const PolygonSchema = yup
  .object()
  .shape({
    polygonId: yup.number(),
    ...PolygonShape,
  })
  .defined();

export const PolygonListSchema = yup
  .object({
    polygon: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                polygonId: yup.number(),
                ...PolygonShape,
              })
              .defined()
          )
          .defined()
      })
      .defined(),
  })
  .defined();

export const PolygonFormSchema = yup
  .object()
  .shape({
    ...PolygonShape,
  })
  .defined();

  export type IPolygon = yup.InferType<typeof PolygonSchema>;
  export type IPolygonTypesRow = yup.InferType<typeof PolygonListSchema>;
  export type IPolygonForm = yup.InferType<typeof PolygonFormSchema>;
